import React, { useState } from 'react';
import { Menu, Dropdown, Button } from 'antd';
import { DownOutlined } from '@ant-design/icons';

const Sorter = ({ setSortOrder }) => {
  const [selected, setSelected] = useState('Featured');

  const handleMenuClick = (e) => {
    setSortOrder(e.key);
    setSelected(e.domEvent.target.innerText); // Update selected option text
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="featured">Featured</Menu.Item>
      <Menu.Item key="best_selling">Best selling</Menu.Item>
      <Menu.Item key="alpha_asc">Alphabetically, A-Z</Menu.Item>
      <Menu.Item key="alpha_desc">Alphabetically, Z-A</Menu.Item>
      <Menu.Item key="price_asc">Price: Low to High</Menu.Item>
      <Menu.Item key="price_desc">Price: High to Low</Menu.Item>
      <Menu.Item key="date_old_to_new">Date: Old to New</Menu.Item>
      <Menu.Item key="date_new_to_old">Date: New to Old</Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={['click']}>
      <Button
        className="bg-white border border-gray-300 hover:border-gray-400 px-4 py-2 text-left rounded-2xl shadow-sm flex justify-between items-center text-gray-800 hover:text-gray-800 focus:outline-none focus:ring-0"
        style={{
          color: 'inherit',
          borderColor: '#D1D5DB', // Border gray-300
        }}
      >
        <div className='me-3'>
        {selected}
        </div>
         <DownOutlined />
      </Button>
    </Dropdown>
  );
};

export default Sorter;
